import Container from './container';
import Header from './header';
import Main from './main';
import Aside from './aside';
import Button from  './button';
import Popup from './popup';

const components = [
  Container,
  Header,
  Button,
  Popup,
  Main,
  Aside,
];

const install = Vue => {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.hasOwnProperty('Vue')) {
  install(window.Vue);
}

export default {
  version: '0.0.1',
  install,
  Container,
  Button,
  Header,
  Popup,
  Main,
  Aside,
};



// WEBPACK FOOTER //
// ./src/components/anyUI/index.js